import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { FileService, type Report } from 'services/files';

export const useFetchReportsHistory = (patientId: string): UseQueryResult<Report[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_REPORTS_HISTORY, patientId],
    queryFn: () => FileService.getReportsByPatient(patientId),
    select: response => response.data,
    enabled: !!patientId,
  });
